import React, {useState, useEffect} from 'react'

export default function CountdownTimer({
  initialSeconds = 60,
  action,
}: {
  initialSeconds?: number
  action?: () => void
}) {
  const [timeLeft, setTimeLeft] = useState(initialSeconds)

  useEffect(() => {
    if (timeLeft <= 0) {
      action?.()
      return // stop if countdown reaches zero
    }

    const timerId = setInterval(() => {
      setTimeLeft((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(timerId) // cleanup on unmount
    // eslint-disable-next-line
  }, [timeLeft])

  // Format as mm:ss
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60)
    const s = seconds % 60
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
  }

  return (
    <div style={{fontSize: '2rem', fontWeight: 'bold'}}>
      {timeLeft > 0 ? formatTime(timeLeft) : "Time's up!"}
    </div>
  )
}
